import { PowerGenerationSourceEnum } from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';

export class CompensationCategoryModel {
  id: number;
  name: string;
  powerRange: CompensationCategoryConditionEnum;
  generationSource: PowerGenerationSourceEnum;
  compensationAmount = 0;
  validFrom: Date;
  validTo: Date;
  isFullFeed = false;
}

export enum CompensationCategoryConditionEnum {
  None = 'None',
  BETWEEN_0KW_10KW = 'BETWEEN_0KW_10KW',
  BETWEEN_10KW_40KW = 'BETWEEN_10KW_40KW',
  BETWEEN_40KW_750KW = 'BETWEEN_40KW_750KW',
  BETWEEN_40KW_100KW = 'BETWEEN_40KW_100KW',
  BETWEEN_100KW_400KW = 'BETWEEN_100KW_400KW',
  BETWEEN_400KW_1000KW = 'BETWEEN_40ßKW_1000KW',
  BETWEEN_40KW_1000KW = 'BETWEEN_40KW_1000KW'
}
